import React from 'react';
import { t } from '../i18n';
import LegalPage from './LegalPage';
import LegalDocument from './LegalDocument';

// Agency agreement with authors (ИП Лебедянский): an appendix to the author offer (/author-offer).
// Creators accept it with the "place my novels on plotex.io" checkbox in their profile (ainovel.ru).
// Text and translations live in src/legal/agency.*.js.
const AgencyAgreementPage = () => (
  <LegalPage title={t('Оферта о заключении агентского договора')}>
    <LegalDocument id="agency" />
  </LegalPage>
);

export default AgencyAgreementPage;
